<template>
    <!--弹窗-->
    <el-dialog
        width="90%"
        title=""
        top="3vh"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <div class="dialogCon">
            <div class="subTitle">1. 基础信息</div>
            <el-row class="lineItem">
                <el-col :span="6">
                    <img style="width:90px;height:90px;" :src="formData.img_url" v-if="formData.img_url"/>
                    <img style="width:90px;height:90px;" src="../../assets/image/img.png" v-if="!formData.img_url"/>
                </el-col>
                <el-col :span="6">
                    <div class="itemInfo">
                        <div class="itemTitle">ID:</div>
                        <div class="itemContent">{{ formData.id }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">ASIN:</div>
                        <div class="itemContent">
                            <icon-svg :icon-class="formData.state.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;" v-if="formData.state"></icon-svg>
                            {{ formData.asin }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">销售国家:</div>
                        <div class="itemContent" v-if="formData.category_state">
                            <icon-svg :icon-class="formData.category_state.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">创建时间:</div>
                        <div class="itemContent">{{ formData.create_time }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">创建人员:</div>
                        {{ formData.creator_username }}
                        <span v-show="formData.creator_fullname">（{{ formData.creator_fullname }}）</span>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">选品原则:</div>
                        <div class="itemContent">{{ formData.selection_principle }}</div>
                    </div>

                </el-col>
                <el-col :span="6">
                    <div class="itemInfo">
                        <div class="itemTitle">类目:</div>
                        <div class="itemContent" @click="showInfo('类目', formData.category)">{{
                                formData.category
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">标题:</div>
                        <div class="itemContent" @click="showInfo('标题', formData.title)">{{ formData.title }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">父ASIN:</div>
                        <div class="itemContent">{{ formData.parentAsin }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">上架时间:</div>
                        <div class="itemContent">{{ formData.listed_since }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">品牌:</div>
                        <div class="itemContent" @click="showInfo('品牌', formData.brand)">{{ formData.brand }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">标品类型:</div>
                        <div class="itemContent">{{ formData.standard_product_type == -1 ? '未录入' : formData.standard_product_type }}</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="itemInfo">
                        <div class="itemTitle">销量:</div>
                        <div class="itemContent">{{ formData.sale_volume }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">评分:</div>
                        <div class="itemContent">{{ formData.rating }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">评论数:</div>
                        <div class="itemContent">{{ formData.rating_count }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">是否季节性:</div>
                        <div class="itemContent">{{ formData.is_seasonality ? '是' : '否' }}</div>

                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">季节:</div>
                        <div class="itemContent">{{ formData.season }}</div>
                    </div>

                </el-col>
            </el-row>
        </div>
        <div class="lineDom"></div>

        <div class="dialogCon">
            <el-row class="lineItem">
                <el-col :span="6">
                    <div class="subTitle2">2. 1688产品</div>

                    <div class="itemInfo">
                        <img style="width:90px;height:90px;" src="../../assets/image/img.png"
                             v-if="!formData.ali_pic_url"/>
                        <img style="width:90px;height:90px;" :src="formData.ali_pic_url" v-if="formData.ali_pic_url"/>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">图片路径:</div>
                        <div class="itemContent" @click="showInfo('图片路径', formData.ali_pic_url)">
                            {{ formData.ali_pic_url }}
                        </div>
                        <el-button type="primary" size="mini" @click="showInfo('图片路径', formData.ali_pic_url)">复制
                        </el-button>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1688产品标题:</div>
                        <div class="itemContent" @click="showInfo('标题', formData.ali_title)">{{
                                formData.ali_title
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1688产品价格:</div>
                        <div class="itemContent">{{ formData.ali_factory_price }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1688产品链接:</div>
                        <div class="itemContent" @click="showInfo('产品链接', formData.ali_href_link)">
                            {{ formData.ali_href_link }}
                        </div>
                        <el-button v-show="formData.ali_href_link" type="primary" size="mini"
                                   @click="jumpUrl(formData.ali_href_link)">跳转
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="subTitle2">3. 采购情况</div>
                    <div class="itemInfo">
                        <div class="itemTitle">分配采购时间:</div>
                        <div class="itemContent">
                            {{ formData.assign_developer_time }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">采购人员:</div>
                        <div class="itemContent">
                            {{ formData.developer_username }}
                            <span v-show="formData.developer_fullname">（{{ formData.developer_fullname }}）</span>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">采购状态:</div>
                        <div class="itemContent">{{
                                formData.purchase_status == 0 ? '选品中' : formData.purchase_status == 1 ? '采购中' : '采购完成'
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">采购完成时间:</div>
                        {{ formData.assign_developer_finish_time }}
                    </div>
                </el-col>
                <el-col :span="6"></el-col>
                <el-col :span="6"></el-col>
            </el-row>
        </div>
        <div class="lineDom"></div>

        <div class="dialogCon">
            <div class="subTitle">4. 成本分析</div>
            <el-row class="lineItem">
                <el-col :span="6">
                    <div class="subTitle2">调节参数</div>

                    <div class="itemInfo">
                        <div class="itemTitle">销售价格:</div>
                        <div class="itemContent">{{ formData.selling_price }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-长(cm):</div>
                        <div class="itemContent">{{ formData.long }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-宽(cm):</div>
                        <div class="itemContent">{{ formData.wide }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-高(cm):</div>
                        <div class="itemContent">{{ formData.height }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">规格-重(g):</div>
                        <div class="itemContent">{{ formData.weight }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">退货率:</div>
                        <div>{{ parseFloat((formData.refund_rate || 0) * 100).toFixed(2) }}%</div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="subTitle2">运输情况</div>

                    <div class="itemInfo">
                        <div class="itemTitle">指定运输模式:</div>
                        <div class="itemContent">
                            {{ formData.set_deliver_mode }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运输模式:</div>
                        <div class="itemContent">
                            {{ formData.deliver_mode }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">总运费:</div>
                        <div class="itemContent">
                            {{ formData.freight }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运费单价/kg:</div>
                        <div class="itemContent">
                            {{ formData.freight_unit_price }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">海空运费差价:</div>
                        <div class="itemContent">
                            {{ formData.freight_difference }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="subTitle2">计算情况</div>
                    <div class="itemInfo">
                        <div class="itemTitle">美国服装商品:</div>
                        <div class="itemContent">
                            {{ formData.is_us_clothing_product ? '是' : '否' }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">美国旺季差额:</div>
                        <div class="itemContent">
                            {{ formData.us_peak_season_balance }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">平台佣金:</div>
                        <div class="itemContent">
                            {{ formData.platform_commission }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">亚马逊物流配送费:</div>
                        <div class="itemContent">
                            {{ formData.delivery_charge }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">退货费用:</div>
                        <div class="itemContent">
                            {{ formData.refund_charge }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">Vat税费:</div>
                        <div class="itemContent">
                            {{ formData.vat_charge }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月仓储费:</div>
                        <div class="itemContent">
                            {{ formData.early_storage_charge }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月仓储费:</div>
                        <div class="itemContent">
                            {{ formData.late_storage_charge }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="subTitle2">利润分析</div>
                    <div class="itemInfo">
                        <div class="itemTitle">符合最低利润要求:</div>
                        <div class="itemContent" style="font-weight: 900"
                             :style="{color: formData.is_conforming_profit == 1 ? 'green': 'red'}">
                            {{ formData.is_conforming_profit ? '是' : '否' }}
                        </div>

                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格:</div>
                        <div class="itemContent">
                            {{ formData.seller_price_no_profit }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">0利润销售价格(免税):</div>
                        <div class="itemContent">
                            {{ formData.seller_price_no_profit_no_tax }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月利润:</div>
                        <div class="itemContent">
                            {{ formData.early_profit }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月利润(免税):</div>
                        <div class="itemContent">
                            {{ formData.early_profit_no_tax }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">1-9月投资回报率:</div>
                        <div class="itemContent">
                            {{
                                formData['early_investment_return_rate'] ? accMul(formData['early_investment_return_rate'], 100) + '%' : '-'
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月利润:</div>
                        <div class="itemContent">
                            {{ formData.late_profit }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月利润(免税):</div>
                        <div class="itemContent">
                            {{ formData.late_profit_no_tax }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">10-12月投资回报率:</div>
                        <div class="itemContent">
                            {{
                                formData['late_investment_return_rate'] ? accMul(formData['late_investment_return_rate'], 100) + '%' : '-'
                            }}
                        </div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">利润率(含税):</div>
                        <div class="itemContent">{{formData['profit_rate'] ? accMul(formData['profit_rate'], 100) + '%' : '-' }}</div>
                    </div>

                    <div class="itemInfo">
                        <div class="itemTitle">利润率(免税):</div>
                        <div class="itemContent">{{formData['profit_rate_no_tax'] ? accMul(formData['profit_rate_no_tax'], 100) + '%' : '-'}}
                        </div>
                    </div>

                </el-col>
            </el-row>
        </div>
        <div class="lineDom"></div>

        <div class="dialogCon">
            <el-row class="lineItem">
                <el-col :span="6">
                    <div class="subTitle2">5.运营情况</div>

                    <div class="itemInfo">
                        <div class="itemTitle">分配运营时间:</div>
                        <div class="itemContent">{{ formData.assign_operation_time }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运营人员:</div>
                        <div class="itemContent">
                            {{ formData.operator_username }}
                            <span v-show="formData.operator_fullname">（{{ formData.operator_fullname }}）</span>
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运营状态:</div>
                        <div class="itemContent">{{
                                formData.operation_status == 0 ? '待运营' : formData.operation_status == 1 ? '运营中' : '不再运营'
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">开始运营时间:</div>
                        <div class="itemContent">{{ formData.operation_running_time }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">运营Asin:</div>
                        <div class="itemContent">{{ formData.operator_asin }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">不再运营时间:</div>
                        <div class="itemContent">{{ formData.operation_fail_time }}</div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">不再运营原因:</div>
                        <div class="itemContent" @click="showInfo('不再运营原因', formData.fail_reason)">{{
                                formData.fail_reason
                            }}
                        </div>
                    </div>

                </el-col>
                <el-col :span="6">
                    <div class="subTitle2">6. 包装情况</div>
                    <div class="itemInfo">
                        <div class="itemTitle">包装物名称:</div>
                        <div class="itemContent" @click="showInfo('包装物名称', formData.wrappage)">{{
                                formData.wrappage
                            }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">包装物-长(cm):</div>
                        <div class="itemContent">
                            {{ formData.wrappage_long }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">包装物-宽(cm):</div>
                        <div class="itemContent">
                            {{ formData.wrappage_wide }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">包装物-高(cm):</div>
                        <div class="itemContent">
                            {{ formData.wrappage_height }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">包装物-链接:</div>

                        <div class="itemContent"
                             @click="showInfo('包装物-链接', formData.wrappage_link)">{{
                            formData.wrappage_link
                            }}
                        </div>

                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">采购规格备注:</div>
                        <div class="itemContent"
                             @click="showInfo('采购规格备注', formData.purchase_specification_remark)">{{
                                formData.purchase_specification_remark
                            }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="6">
                    <div class="subTitle2">7. 其他属性</div>

                    <div class="itemInfo">
                        <div class="itemTitle">管理员选库:</div>
                        <div class="itemContent" style="font-weight: 900"
                             :style="{color: formData.manager_cost_analysis_task_id ? 'blue': 'black'}">
                            {{ formData.manager_cost_analysis_task_id ? '是' : '否' }}
                        </div>
                    </div>
                    <div class="itemInfo">
                        <div class="itemTitle">再审核Asin:</div>
                        <div class="itemContent" style="font-weight: 900"
                             :style="{color: formData.audits_number == 0 ? 'black' : 'blue'}">
                            {{ formData.audits_number == 0 ? '否' : '是' }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
        </span>
        <child-info-modal :visible="childInfoVisible" :info="previewInfo"
                          @close-callback="closeCllback"></child-info-modal>
    </el-dialog>
</template>
<script>

import childInfoModal from '@/views/warehouse/childInfoModal.vue'

export default {
    components: {childInfoModal},
    data() {
        return {
            visible: false,
            formData: {},
            childInfoVisible: false,
            previewInfo: {},
        }
    },
    methods: {
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        closeCllback() {
            this.childInfoVisible = false
            this.previewInfo = {}
        },
        showInfo(title, info) {
            console.log('==')
            this.previewInfo = {title, info}
            this.childInfoVisible = true
        },
        showModal(data) {
            this.formData = data
            this.visible = true
        },
        // 关闭弹窗
        handleClose() {
            this.visible = false
            // this.$emit('close-callback', this.closeFlag)
        },
        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },
        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        spanMethod({row, column, rowIndex, columnIndex}) {

            const columns = [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28]
            if (rowIndex % 3 == 0) {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 3,
                    colspan: 1
                }
            } else {
                if (columns.includes(columnIndex)) {
                    return {
                        rowspan: 1,
                        colspan: 1
                    }
                }
                return {
                    rowspan: 0,
                    colspan: 0
                }
            }
        },
    }
}
</script>
<style type="text/scss" lang="scss">
.subTitle {
    height: 30px;
    font-size: 18px;
    font-weight: 800;
    margin: 5px 0 0;
}

.subTitle2 {
    height: 20px;
    font-size: 16px;
    font-weight: 800;
}

.itemInfo {
    display: flex;

    .itemTitle {
        font-size: 14px;
        color: #606266;
        padding: 0 12px 0 0;
        font-weight: 800;
    }

    .itemContent {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

.itemInfo:not(:first-child) {
    margin-top: 5px;
}

.lineDom {
    width: auto;
    height: 1px;
    background: black;
    margin: 10px 0;
}

.wrapBox {
    width: 600px;
    margin-top: 10px;

    .bottomBox {
        margin-top: 17px;
        display: flex;
        justify-content: center;
    }
}

.download {
    display: flex;
    justify-content: center;
}

.top {
    margin: 0px auto 20px;
    width: 60%;
    display: flex;
    justify-content: space-between;
}
</style>

